import { URLParameters } from '@/app/common/urlParameters.ts';
import type { Filter } from '@/app/common/filters/core/filtersTypes.ts';
import {
  getTranslationServer,
  type TranslationDictionary,
} from '@/app/components/translations/createTranslationDictionary.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import { createSearchDynamicFilter } from '@/app/common/filters/groups/filterGroupsUtils.ts';

type CreatePropertyNameFiltersProps = {
  searchParams: SearchParams;
  translationDictionary: TranslationDictionary;
};
export const createPropertyNameFilters = ({
  searchParams,
  translationDictionary,
}: CreatePropertyNameFiltersProps): Filter[] =>
  createSearchDynamicFilter({
    filterName: FILTER_NAME.PROPERTY_NAME,
    searchParams,
    urlParameterName: URLParameters.ACCOMODATION_NAME,
    label: getTranslationServer('vacation.oss.filters.property.title', translationDictionary),
    placeholder: getTranslationServer('vacation.oss.filters.property.placeholder', translationDictionary),
    noResultsLabel: getTranslationServer('vacation.oss.filters.districts.no_matches', translationDictionary),
  });
